import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import {
  formatDate,
  formatDateForInput,
  parseDateString,
  resultForRecoveryForm,
} from "../constant";
import useAxios from "../common/hook/useAxios";
import { toast } from "react-toastify";
import Dropdown from "./Dropdown";
import { AuthContext } from "../context/AuthContext";
import { FaCircleXmark } from "react-icons/fa6";

const RecoveryForm = ({ isModal, toggleMenu, value, handleSearch }) => {
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [analyte, setAnalyte] = useState([]);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    if (
      Object.keys(value).length > 0 &&
      value?.orderType !== "" &&
      value?.lab !== ""
    ) {
      fetchAnalyte();
    }
  }, [value]);

  const fetchAnalyte = () => {
    const objInput = {
      sTestType: value?.orderType,
      sLabID: value?.lab,
    };
    const sInputJSON = JSON.stringify(objInput);
    const url =
      process.env.REACT_APP_TEMPLATES_URL +
      "/LabReport/GetLabTestAnalytes?sInputJSON=" +
      sInputJSON;
    request(url, {
      method: "GET",
    })
      .then((data) => {
        setAnalyte(data?.Data);
      })
      .catch(() => {
        toast.error("Error occured while fetching analytes", {
          autoClose: 3000,
        });
      });
  };

  useEffect(() => {
    if (Array.isArray(analyte) && analyte.length > 0) {
      // Initialize tableData based on the length of analyte
      setTableData(
        analyte.map(() => ({
          selectedResult: resultForRecoveryForm[0]?.value || "", // Default to the first option in the dropdown
          comments: "", // Default value for comments is empty
        })),
      );
    }
  }, [analyte]);

  // Handle changes in dropdown selection
  const handleDropdownChange = (index, value) => {
    // Ensure the index is valid before updating tableData
    if (index >= 0 && index < tableData.length) {
      const newTableData = [...tableData]; // Clone the tableData
      newTableData[index].selectedResult = value; // Update the selectedResult
      setTableData(newTableData); // Set the updated tableData
    } else {
      console.error("Invalid index in handleDropdownChange:", index);
    }
  };

  // Handle changes in comment input field
  const handleCommentChange = (index, value) => {
    // Ensure the index is valid before updating tableData
    if (index >= 0 && index < tableData.length) {
      const newTableData = [...tableData]; // Clone the tableData
      newTableData[index].comments = value; // Update the comments
      setTableData(newTableData); // Set the updated tableData
    } else {
      console.error("Invalid index in handleCommentChange:", index);
    }
  };

  const saveRecoveryForm = (isFinalize) => {
    // Validation: Check if all comments are provided
    // const missingComments = tableData.some(
    //   (data) => data.comments.trim() === "",
    // );

    // if (missingComments) {
    //   toast.error("All comments must be entered.", {
    //     autoClose: 3000,
    //   });
    //   return; // Don't proceed with the form submission if comments are missing
    // }

    // Map tableData to arrResult
    const arrResult = tableData
      .map((data, index) => {
        const analyteItem = analyte[index]; // Use analyte[index] for the AnalyteID
        if (analyteItem) {
          return {
            sAnalyteID: analyteItem?.AnalyteID, // Analyte ID from the analyte data
            sTestResult: data.selectedResult, // Result selected by the user
            sComments: data.comments, // Comment from the user
          };
        } else {
          return null;
        }
      })
      .filter((item) => item !== null);
    const objInput = {
      objLab: {
        iSavedFlag: value?.iSavedFlag,
        sPracticeID: user?.PracticeID,
        sPatientID: value?.patientId,
        sDOS: value?.appointmentDate,
        sRequisitionNumber: value?.requisitionNumber,
        sTestType: value?.orderType,
        sAddedBy: user?.userId,
        arrResult,
        isFinalize,
        sResultDate: formatDate(resultDate),
        sResultTime: "",
        sReportDate: formatDate(reportDate),
        sReportTime: "",
        sReceivedDate: formatDate(reportDate),
      },
    };
    const stringifiedObjInput = JSON.stringify(JSON.stringify(objInput));
    // console.log(stringifiedObjInput);

    request(process.env.REACT_APP_TEMPLATES_URL + "/LabReport/SaveLabResults", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
        "Content-Type": "application/json",
      },
      data: stringifiedObjInput,
    })
      .then((res) => {
        //if (res.status = 200) 
        {
          toast.success("Report Saved", {
            autoClose: 3000,
          });
        }
        toggleMenu()
        handleSearch()
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error occured while saving report", {
          autoClose: 3000,
        });
      });

    // Make the API request to save the data...
  };

  const [recievedDate, setRecievedDate] = useState(new Date());
  const [reportDate, setReportDate] = useState(new Date());
  const [resultDate, setResultDate] = useState(new Date());
  const [error, setError] = useState("");
  return (
    <div>
      {" "}
      <Modal
        isOpen={isModal}
        onRequestClose={toggleMenu}
        className={`absolute flex flex-col top-8 left-[60%] transform -translate-x-1/2 p-4 w-[1000px] bg-blue-200 shadow-lg rounded-lg transition-transform duration-300 ease-in-out ${isModal ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"}`}
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity overflow-y-auto"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        <div className="flex justify-end items-center">
          <FaCircleXmark className="my-2 text-lg cursor-pointer text-red-600" onClick={toggleMenu} />
        </div>
        <div className="flex flex-row justify-between items-center">
          <img
            src="https://www.healthiva.com/images/lab_logo.png"
            className="w-72 h-32 mb-2"
          />
          <div className="flex flex-col font-medium">
            <p>Phone: (614) 792-6242</p>
            <p>Fax: (614) 792-6242</p>
            <p>CLIA ID-36D2083495</p>
            <p>Lab Director: David Wells, PhD</p>
          </div>
        </div>
        <div className="grid grid-cols-5 bg-blue-200">
          <div className="border border-gray-200 col-span-2">
            <h3 className="bg-blue-500 text-white p-1">Patient</h3>
            <div className="flex flex-col text-sm my-4">
              <p className="block text-md font-medium p-1">
                Patient Name : {value?.firstName}
              </p>
              <p className="block text-md font-medium my-2 p-1">
                Patient ID : {value?.MRN}
              </p>
              <p className="block text-md font-medium p-1">
                Gender : {value?.sex}
              </p>
              <p className="block text-md font-medium my-2 p-1">
                DOB : {value?.dob}
              </p>
            </div>
          </div>
          <div className="border border-gray-200 col-span-2 text-left">
            <h3 className="bg-blue-500 text-white p-1">Specimen</h3>
            <div className="flex flex-col text-sm">
              <p className="block text-md font-medium my-2 p-1">
                Requisition Number : {value?.requisitionNumber}
              </p>
              <p className="block text-md font-medium p-1">
                Collection Date : {value?.appointmentDate}
              </p>
              <div className="flex flex-row items-center justify-left">
                <label
                  htmlFor="to-date"
                  className="block text-md font-medium p-1"
                >
                  Recieved Date :
                </label>
                <input
                  type="date"
                  id="to-date"
                  value={formatDateForInput(recievedDate)}
                  onChange={(e) => {
                    const dateString = e.target.value;
                    const newDate = parseDateString(dateString);
                    if (newDate) {
                      setRecievedDate(newDate);
                      setError("");
                    } else {
                      setError("Invalid date format.");
                    }
                  }}
                  className="mt-1 ml-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
              <div className="flex flex-row justify-left items-center">
                <label
                  htmlFor="to-date"
                  className="block text-md font-medium text-white-300 p-1"
                >
                  Report Date :
                </label>
                <input
                  type="date"
                  id="to-date"
                  value={formatDateForInput(reportDate)}
                  onChange={(e) => {
                    const dateString = e.target.value;
                    const newDate = parseDateString(dateString);
                    if (newDate) {
                      setReportDate(newDate); // Update the state with Date object
                      setError("");
                    } else {
                      setError("Invalid date format.");
                    }
                  }}
                  className="mt-1 ml-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
              <div className="flex flex-row items-center justify-left">
                <label
                  htmlFor="to-date"
                  className="block text-md font-medium text-white-300 p-1"
                >
                  Result Date :
                </label>
                <input
                  type="date"
                  id="to-date"
                  value={formatDateForInput(resultDate)}
                  onChange={(e) => {
                    const dateString = e.target.value;
                    const newDate = parseDateString(dateString);
                    if (newDate) {
                      setResultDate(newDate); // Update the state with Date object
                      setError("");
                    } else {
                      setError("Invalid date format.");
                    }
                  }}
                  className="mt-1 ml-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>
          </div>

          <div className="border border-gray-200">
            <h3 className="bg-blue-500 text-white p-1">Physician</h3>
            <div className="flex flex-col text-sm font-medium mt-4">
              <p className="block text-md font-medium text-white-300 p-1">
                Provider Name : {value?.providerName}
              </p>
              <p className="my-2 block text-md font-medium text-white-300 p-1">
                Location : BC
              </p>
              <p className="block text-md font-medium text-white-300 p-1">
                Client : #
              </p>
              <p className="my-2 block text-md font-medium text-white-300 p-1">
                Phone :
              </p>
            </div>
          </div>
        </div>
        <div className="p-4">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-blue-500 border-b text-white">
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  #
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Analyte
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Results
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Comment
                </th>
              </tr>
            </thead>{" "}
            <tbody>
              {Array.isArray(analyte) &&
                analyte.map((row, index) => (
                  <tr key={index + 1} className="border-b font-medium text-md bg-gray-300">
                    <td className="p-2 border-r">{index + 1}</td>
                    <td className="p-2 border-r">{row?.AnalyteName}</td>
                    <td className="p-2 border-r">
                      <Dropdown
                        items={resultForRecoveryForm}
                        setSelectedValue={(value) =>
                          handleDropdownChange(index, value)
                        }
                        type="no-label"
                        isHeader={true}
                        selectedValue={tableData[index]?.selectedResult}
                      />
                    </td>
                    <td className="p-2 border-r">
                      <input
                        type="text"
                        className="text-gray-800 text-sm mt-1"
                        placeholder="Enter Comments"
                        value={tableData[index]?.comments || ""}
                        onChange={(e) =>
                          handleCommentChange(index, e.target.value)
                        }
                        style={{ marginBottom: "10px", padding: "5px" }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-row justify-end items-center gap-3">
          <button
            onClick={() => {
              saveRecoveryForm(0);
            }}
            className="bg-orange hover:bg-orange-600 mt-2 w-1/4 block text-md font-medium text-white p-2 rounded-lg"
          >
            Save
          </button>
          <button
            onClick={() => {
              saveRecoveryForm(1);
            }}
            className="bg-orange hover:bg-orange-600 mt-2 w-1/4 block text-md font-medium text-white p-2 rounded-lg"
          >
            Finalize
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default RecoveryForm;
